import { BsCameraVideo, BsCameraVideoOffFill, BsMic, BsMicMuteFill } from 'react-icons/bs';

import { OButton } from '@src/shared';
import AvatarCircle from '../AvatarCircle';
import { ParticipantsActionsMenu } from './partials';

import useParticipantsList from './useParticipantsList';

import { WhiteRaisedHandLabel } from '@src/assets/icons';

import './ParticipantsList.scss';

const ParticipantsList = () => {
  const {
    hoveredRow,
    participantsPeers,
    handleMouseEnter,
    handleMouseLeave,
    handleMuteParticipant,
    canUserMute,
    handleLowerAllRaisedHands,
    isHostOrCohost,
    raisedHandsQueue,
  } = useParticipantsList();

  return (
    <div className="participants-list-container">
      {isHostOrCohost && (
        <div className="lower-hands-container">
          <OButton
            grayOutlined={true}
            isDisabled={raisedHandsQueue.length === 0}
            text="Lower all raised hands"
            onClick={handleLowerAllRaisedHands}
          />
        </div>
      )}
      {!!participantsPeers.length &&
        participantsPeers.map((participant) => {
          const {
            peer_info: { peer_id, peer_name: peerName, peer_audio, peer_video },
            handRaiseOrder,
            isMe,
          } = participant;
          const isHovered = !isMe && hoveredRow === peer_id;

          return (
            <div
              className={`participant-row ${isHovered ? 'hovered' : ''}`}
              key={peer_id}
              onMouseEnter={() => handleMouseEnter(peer_id)}
              onMouseLeave={() => handleMouseLeave()}
            >
              <div className="participant-info">
                <AvatarCircle peerId={peer_id} avatarImgSize={36} />
                <span className="participant-name">{peerName + (isMe ? ' (Me)' : '')}</span>
              </div>
              <div className="actions-container">
                {isHovered ? (
                  <>
                    {canUserMute && peer_audio && (
                      <OButton text={'Mute'} size="small" onClick={() => handleMuteParticipant(peer_id)} />
                    )}
                    <ParticipantsActionsMenu participant={participant} />
                  </>
                ) : (
                  <div className="icons-container">
                    {handRaiseOrder && (
                      <div className="raise-hand-container">
                        <span className="hand-order">{handRaiseOrder}</span>
                        <WhiteRaisedHandLabel />
                      </div>
                    )}

                    <div
                      className={`icon-container ${!peer_audio ? 'closed ' : ''}`}
                      style={{
                        cursor: 'unset',
                        ...(peer_audio ? { backgroundColor: 'var(--participant-mic-color)' } : {}),
                      }}
                    >
                      {!peer_audio ? <BsMicMuteFill /> : <BsMic style={{ fill: 'var(--drawer-icon-color)' }} />}
                    </div>
                    <div
                      className={`icon-container ${!peer_video ? 'closed ' : ''}`}
                      style={{
                        cursor: 'unset',
                        ...(peer_video ? { backgroundColor: 'var(--participant-mic-color)' } : {}),
                      }}
                    >
                      {!peer_video ? (
                        <BsCameraVideoOffFill />
                      ) : (
                        <BsCameraVideo style={{ fill: 'var(--drawer-icon-color)' }} />
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default ParticipantsList;
